














































import Axios, { AxiosResponse } from 'axios'
import { Vue, Component } from 'vue-property-decorator'
import API from '@/util/api/API'
import { Nullable, Maybe } from '@/types/general'
import { Picker as EmojiPicker } from 'emoji-mart-vue-fast'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import { FONT_AWESOME } from './icons'

@Component({ name: 'icon-selector-panel', components: { EmojiPicker } })
export default class IconSelectorPanel extends Vue {
    showEmojis: boolean = false

    searchTerm: string = ''

    setSearchTerm(value: string): void {
        this.searchTerm = value
    }

    setShowEmojis(value: boolean): void {
        this.showEmojis = value
    }

    setEmoji(value: string): void {
        this.$emit('input', `emoji:${value}`)
    }

    setIcon(value: string): void {
        this.$emit('input', `icon:${value}`)
    }

    get filteredFAIcons(): string[] {
        return FONT_AWESOME.filter(icon => icon.includes(this.searchTerm))
    }
}
